<template>
    <div>
        <div class="updater-container" v-if="shouldDisplayUpdater">
            <Modal :title="$t('New update available')" @close="dismissUpdate">
                <template v-slot:modal-header-button-start>
                    <button @click="dismissUpdate" class="btn btn-icon">
                        <iconLeft width="24" height="24" aria-hidden="true" />
                    </button>
                </template>
                <p>
                    {{
                        $t(
                            "There's a new update available, would you like to update?"
                        )
                    }}
                </p>
                <p
                    class="version-diff"
                    v-html="
                        $t('New version is: <strong>{version}</strong>', {
                            version: readableServerVersion,
                        })
                    "
                ></p>
                <p
                    class="version-diff"
                    v-html="
                        $t('Your version is: <strong>{version}</strong>', {
                            version: readableMyVersion,
                        })
                    "
                ></p>

                <div class="buttons">
                    <button
                        class="btn btn-tertiary btn-size-lg"
                        @click.prevent="dismissUpdate"
                    >
                        {{ $t("No thanks") }}
                    </button>
                    <button
                        class="btn btn-secondary btn-size-lg"
                        @click="refresh"
                    >
                        {{ $t("Update now") }}
                    </button>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

import Modal from "@/components/Modal";
import iconLeft from "@/assets/icons/icon-arrow-left.svg";
import LocalStorage from "@/lib/LocalStorage";

export default {
    name: "UpdaterContainer",
    components: {
        Modal,
        iconLeft,
    },
    computed: {
        ...mapGetters("updater", [
            "shouldDisplayUpdater",
            "readableServerVersion",
            "myVersion",
            "readableMyVersion",
        ]),
        ...mapState("updater", ["server_version"]),
    },
    methods: {
        ...mapMutations("updater", ["postponeUpdate", "setIsOutOfDate"]),

        dismissUpdate() {
            this.postponeUpdate(true);
        },
        async refresh() {
            if (
                navigator.serviceWorker &&
                navigator.serviceWorker.getRegistrations
            ) {
                const registrations =
                    await navigator.serviceWorker.getRegistrations();

                for (let registration of registrations) {
                    registration.unregister();
                }
            }

            LocalStorage.SetItem(
                "updater",
                JSON.stringify({
                    postpone: true,
                    version: this.server_version,
                })
            );

            document.location.reload();
            this.setIsOutOfDate(false);
        },
    },
};
</script>
<style lang="scss">
@use "index";

.version-diff {
    margin-top: 0.25em;
    margin-bottom: 0.25em;
    padding: 0;
}
</style>
